var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1781 19.569C11.2698 19.7022 11.3926 19.8112 11.5357 19.8864C11.6789 19.9617 11.8383 20.001 12.0001 20.001C12.1618 20.001 12.3212 19.9617 12.4644 19.8864C12.6076 19.8112 12.7303 19.7022 12.8221 19.569L21.8221 6.569C21.9262 6.41906 21.9873 6.24343 21.9987 6.06121C22.0101 5.87898 21.9713 5.69712 21.8865 5.53539C21.8018 5.37366 21.6744 5.23825 21.5181 5.14386C21.3618 5.04947 21.1826 4.99971 21.0001 5H3.00006C2.8179 5.00075 2.6394 5.05115 2.48374 5.14576C2.32808 5.24038 2.20116 5.37564 2.11663 5.53699C2.03209 5.69835 1.99314 5.8797 2.00397 6.06153C2.01479 6.24337 2.07498 6.41881 2.17806 6.569L11.1781 19.569Z",
    fill: "#BD3193"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.c7965508060a353a1e8271796e1bdf51.svg";
export { ForwardRef as ReactComponent };